import { action, makeObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class RecommendedTabStore {
  totalRecommendedCategories = 0;
  recommendationsData: any[] = [];
  categoryToBeCalled: string = '';
  columnsInRecommendedTable: any[] = [];
  dataInRecommendedTable: any[] = [];
  additionalData:string='';
  categoryData:string='';
  specificDeductibleValue:string='';
  constructor() {
    makeObservable(this, {
      totalRecommendedCategories: observable,
      recommendationsData: observable,
      categoryToBeCalled: observable,
      columnsInRecommendedTable: observable,
      dataInRecommendedTable: observable,
      specificDeductibleValue: observable,
      setTotalRecommendedCategories: action,
      removeTotalRecommendedCategories: action,
      setRecommendationsData: action,
      removeRecommendationsData: action,
      setCategoryToBeCalled: action,
      removeCategoryToBeCalled: action,
      setColumnsInRecommendedTable: action,
      setCategoryAdditionalData:action,
      setCategoryData:action,
      removeColumnsInRecommendedTable: action,
      setDataInRecommendedTable: action,
      removeDataInRecommendedTable: action,
      setSpecificDeductibleValue:action,
      removeSpecificDeductibleValue:action
    });
    makePersistable(this, {
      name: 'RecommendedTabStore',
      properties: [
        'totalRecommendedCategories',
        'recommendationsData',
        'categoryToBeCalled',
        'columnsInRecommendedTable',
        'dataInRecommendedTable',
        'additionalData',
        'categoryData',
        'specificDeductibleValue'
      ],
      storage: window.localStorage,
    });
  }

  setTotalRecommendedCategories(totalRecommendedCategories: number) {
    this.totalRecommendedCategories = totalRecommendedCategories;
  }

  removeTotalRecommendedCategories() {
    this.totalRecommendedCategories = 0;
  }

  setRecommendationsData(recommendationsData: any[]) {
    this.recommendationsData = recommendationsData;
  }

  removeRecommendationsData() {
    this.recommendationsData = [];
  }

  setCategoryToBeCalled(categoryToBeCalled: string) {
    this.categoryToBeCalled = categoryToBeCalled;
  }

  removeCategoryToBeCalled() {
    this.categoryToBeCalled = '';
  }

  setColumnsInRecommendedTable(columnsInRecommendedTable: any[]) {
    this.columnsInRecommendedTable = columnsInRecommendedTable;
  }

  removeColumnsInRecommendedTable() {
    this.columnsInRecommendedTable = [];
  }

  setCategoryAdditionalData(additionalData: string) {
    this.additionalData = additionalData;
  }

  removeCategoryAdditionalData() {
    this.additionalData = '';
  }

  setCategoryData(categoryData: string) {
    this.categoryData = categoryData;
  }

  removeCategory() {
    this.categoryData = '';
  }

  setDataInRecommendedTable(dataInRecommendedTable: any[]) {
    this.dataInRecommendedTable = dataInRecommendedTable;
  }

  removeDataInRecommendedTable() {
    this.dataInRecommendedTable = [];
  }
  setSpecificDeductibleValue(specificDeductibleValue:string){
    this.specificDeductibleValue = specificDeductibleValue;
  }
  removeSpecificDeductibleValue(){
    this.specificDeductibleValue='';
  }
}
